import { render, staticRenderFns } from "./ResourceMonitor.vue?vue&type=template&id=047a68e7&scoped=true"
import script from "./ResourceMonitor.vue?vue&type=script&lang=js"
export * from "./ResourceMonitor.vue?vue&type=script&lang=js"
import style0 from "./ResourceMonitor.vue?vue&type=style&index=0&id=047a68e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a68e7",
  null
  
)

export default component.exports